<div
  class="row border-t-theme-gray-400 group relative flex scroll-mt-16 scroll-mb-20 flex-row items-center justify-between gap-1 border-t py-2 pr-2 pl-4"
  [ngClass]="isRowToClassify() ? 'bg-theme-gray-500' : 'hover:bg-theme-blue-gray'">
  @for (fieldModel of visibleFieldModels(); track $index) {
    @let fieldIndex = $index;
    @let fieldKey = fieldModel.key;
    @let extractedTableCellForm = row().controls.rowData.controls[fieldKey];
    @let controls = extractedTableCellForm.controls;

    <div
      [ngClass]="fieldModel.widthUtilityClass"
      [attr.data-testid]="fieldKey + '-' + rowIndex()"
      class="h-full">
      @if (fieldModel.type === FieldType.DROPDOWN) {
        <ct-extraction-dropdown
          [control]="controls.value"
          [isOpened]="controls.id.value === this.currentTableFieldId()"
          [header]="fieldModel.label.text"
          [optionLabelByKey]="getDropdownOptions(fieldModel) | inflate"
          (triggerClicked)="rowSelected.emit(undefined); onFieldSelected(fieldIndex)"
          (outsideClick)="onFieldSelected(undefined)"
          (selectValue)="controls.value.setValue($event); onFieldSelected(undefined)" />
      } @else {
        <ct-extraction-table-item-input
          [fieldModel]="fieldModel"
          [control]="controls.value"
          [isActive]="controls.id.value === this.currentTableFieldId()"
          [isFocused]="controls.id.value === this.currentTableFieldId()"
          (focused)="onFieldSelected(fieldIndex)"
          (input)="onUserInput(extractedTableCellForm)" />
      }
    </div>
  }
  @let classification = tableModel().rowClassification;
  @if (classification && isClassificationView()) {
    <ct-extraction-dropdown
      [class]="classification.classColumnWidthUtilityClass"
      [optionLabelByKey]="classification.classes"
      [header]="classification.classLabel"
      [control]="row().controls.class"
      [isOpened]="isRowToClassify()"
      (triggerClicked)="rowSelected.emit(rowIndex()); onFieldSelected(undefined)"
      (selectValue)="
        tableModel().rowClassification!.callbackProvider(row(), $event);
        tableCallback.emit({ currentRowForm: row(), classValue: $event })
      "
      (outsideClick)="outsideClick.emit()" />
  }
  @if (isTableLayoutEditable()) {
    <ct-extraction-edit-table-layout
      [topAndBottomAddLineControls]="topAndBottomAddLineControls()"
      [row]="row().getRawValue()"
      [rowIndex]="rowIndex()"
      (deleteRowAtIndex)="deleteRowAtIndex.emit($event)"
      (rowAdded)="onAddRow($event.index, $event.row)" />
  }
</div>
